import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import moment from "moment";

const getRelativeDateText = (date) => {
  const diffInDays = moment().diff(date, "days");

  if (diffInDays === 0) return "Today";
  if (diffInDays === 1) return "1 day ago";
  if (diffInDays < 30) return `${diffInDays} days ago`;

  if (diffInDays < 365) {
    const months = moment().diff(date, "months");
    return months === 1 ? "1 month ago" : `${months} months ago`;
  }

  const years = moment().diff(date, "years");
  return years === 1 ? "1 year ago" : `${years} years ago`;
};

const RelativeDate = ({ value }) => {
  const date = moment(value);

  return (
    <OverlayTrigger
      placement="top"
      overlay={(props) => (
        <Tooltip id="card-creation-date-tooltip" {...props}>
          {date.format("MMMM Do YYYY, h:mm a")}
        </Tooltip>
      )}
    >
      <span style={{ cursor: "pointer" }}>{getRelativeDateText(date)}</span>
    </OverlayTrigger>
  );
};

export default RelativeDate;
